import { render } from "./SectionSkillsTags.vue?vue&type=template&id=4b31a4e6&scoped=true&ts=true"
import script from "./SectionSkillsTags.vue?vue&type=script&lang=ts"
export * from "./SectionSkillsTags.vue?vue&type=script&lang=ts"

import "./SectionSkillsTags.vue?vue&type=style&index=0&id=4b31a4e6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b31a4e6"]])

export default __exports__